module.exports = __webpack_public_path__ + "static/img/jijian-tips.664c207.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jijian-tips.jpg
// module id = pbq1
// module chunks = 1